module.exports = __webpack_public_path__ + "static/img/6.078a894.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/changeBg/6.png
// module id = wCyz
// module chunks = 0